import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LegalNoticesService, LegalNotice } from '../../../services/legal-notices.service';
import { BreadcrumbComponent, BreadcrumbItem } from '../../common/breadcrumb/breadcrumb.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-rop',
  standalone: true,
  imports: [CommonModule, BreadcrumbComponent, FormsModule],
  templateUrl: './rop.component.html',
  styleUrl: './rop.component.scss'
})
export class RopComponent implements OnInit {
  legalNotices: LegalNotice[] = [];
  filteredNotices: LegalNotice[] = [];
  tipos: string[] = [];
  selectedTipo: string = '';
  isLoading: boolean = true;
  error: string = '';

  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'Información Corporativa', url: '/informaciones' },
    { label: 'Reportes Operaciones Relacionadas' }
  ];

    fechas: string[] = [];
    anios: number[] = [];
    selectedAnio: number = 0;

  constructor(private readonly legalNoticesService: LegalNoticesService) {}

  ngOnInit(): void {
    this.loadLegalNotices();
  }

  extractFechas(): void {
  
    const yearSet = new Set<number>();
  
    this.legalNotices.forEach(doc => {
      if (doc.fecha) {
        console.log(doc.fecha);
        let year: number;
    
        if (typeof doc.fecha === 'string') {
          const parts = doc.fecha.split('-'); // Divide "2023-01-01" en partes
          year = parseInt(parts[0], 10); // Extrae el año manualmente
          yearSet.add(year);
        }
        
      }
    });
  
    this.anios = Array.from(yearSet).sort((a, b) => a - b);
  }



  loadLegalNotices(): void {
    this.isLoading = true;
    this.legalNoticesService.getReporteOperacionales().subscribe({
      next: (data) => {
        this.legalNotices = data.filter(notice => notice.estado).sort((a, b) => b.orden - a.orden);
        this.tipos = [...new Set(this.legalNotices.map(notice => notice.tipo))];
        // Por defecto seleccionar "Bases Legales Clientes"
        this.filterByTipo('ROP');
        this.isLoading = false;
        this.extractFechas();
      },
      error: (error) => {
        // Para desarrollo, mostrar datos de ejemplo si la API no está disponible
        console.warn('API no disponible, usando datos de ejemplo:', error);
        this.isLoading = false;
      }
    });
  }


  filterByTipo(tipo: string): void {
    this.selectedTipo = tipo;
    if (tipo === '') {
      this.filteredNotices = []; // No mostrar nada si no se selecciona un tipo
    } else {
      this.filteredNotices = this.legalNotices.filter(notice => notice.tipo === tipo);
    }
  }

  downloadDocument(url: string): void {
    this.legalNoticesService.downloadDocument(url);
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-CL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  filtrarDocumentosPorAnio(): void {
    if (this.selectedAnio != 0) {
      this.filteredNotices = this.legalNotices.filter(doc => {
        if (doc.fecha) {
          let year: number;
  
          // Extraer año de forma segura
          if (typeof doc.fecha === 'string') {
            const parts = doc.fecha.split('-'); // Dividimos la fecha '2023-01-01'
            year = parseInt(parts[0], 10); // Extraemos el año (parte 0)
          }else {
            return false; // Si no es ni string ni Date, ignoramos el documento
          }
  
          // Comparar el año con selectedAnio
          return year.toString() === this.selectedAnio.toString();
        }
        return false;
      });
    } else {
      // Mostrar todos los documentos si selectedAnio es 0
      this.filteredNotices = this.legalNotices;
    }
  }

    filtroAnio(): void {
    this.filtrarDocumentosPorAnio();
  }

}